import styled from "@emotion/styled";

export const ProductImage = styled.img<{ isOutOfStock?: boolean }>`
  height: 80px;
  width: 60px;
  object-fit: cover;
  border-radius: 4px;
  display: block;
  flex-shrink: 0;
  aspect-ratio: 3/4;
  border-top: 1px solid #f2f2f2;
  border-right: 1px solid #f2f2f2;
  border-left: 1px solid #f2f2f2;
  opacity: ${({ isOutOfStock }) => (isOutOfStock ? 0.5 : 1)};
  filter: ${({ isOutOfStock }) => (isOutOfStock ? "grayscale(100%)" : "none")};
`;
